import type { NavItem } from '@/components/UiNavigation/UiNavigation.types'
import { INVESTOR_SUB_MENU_ITEMS } from '@/domains/investor/components/SubMenu/SubMenu.consts'

export function useInvestorSubMenu() {
  const { t } = useI18n()

  return computed<NavItem[]>(() =>
    INVESTOR_SUB_MENU_ITEMS
      .map(item => ({
        ...item,
        children: item.children?.filter(child => t(child.label)),
      }))
      .filter(item => t(item.label)),
  )
}
